import type { FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import type { sitemapQuery } from "~/queries/__generated__/sitemapQuery.graphql";

import { footerMenuData } from "./data";
import type { FooterMenuData } from "./data";
import { Container, MenuItem, MenuItemBaseLink } from "./styles";

type Props = {
  className?: string;
};

export const PostiesSitemap: FunctionComponent<Props> = ({ className }) => {
  const data = useLazyLoadQuery<sitemapQuery>(
    graphql`
      query sitemapQuery {
        queue(filter: { name: "posties_menu_read" }) {
          items(first: 14) {
            edges {
              node {
                ... on Section {
                  entityId
                  entityUuid
                  urlAlias
                  name
                }
              }
            }
          }
        }
      }
    `,
    {
      name: "posties_menu_read",
    },
  );

  const readColumn: FooterMenuData = [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      name: "Read",
      routeType: "Page",
      urlAlias: "/posties/kids",
    },
    ...(data.queue?.items?.edges?.map(item => ({
      entityId: item.node.entityId ?? "",
      entityUuid: item.node.entityUuid ?? "",
      name: item.node.name ?? "",
      routeType: "Section",
      urlAlias: item.node.urlAlias ?? "",
    })) ?? []),
  ];

  return (
    <Container className={className}>
      {[readColumn, ...footerMenuData].map((menuData, dataIndex) => (
        <MenuItem key={dataIndex}>
          {menuData.map((item, index) => (
            <MenuItemBaseLink $isBold={item?.isBold} key={index} linkEntity={item}>
              {item.name}
            </MenuItemBaseLink>
          ))}
        </MenuItem>
      ))}
    </Container>
  );
};

PostiesSitemap.displayName = "PostiesSitemap";
